import { useEffect, useState, useMemo } from "react";
import CountUp from "react-countup";
import { getRecap } from "../../../services/services";

const Counter = () => {
  const [_recap, _setRecap] = useState(0);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const recap = await getRecap();

        _setRecap(recap);
      } catch (error) {
        console.error("Gagal mengambil data:", error);
      }
    };
    fetchData();
}, []);

  // Hitung experience years
  const experienceYears = useMemo(() => {
    const startYear = new Date(2010, 2, 1);
    const today = new Date();

    let years = today.getFullYear() - startYear.getFullYear();
    const anniversary = new Date(
      today.getFullYear(),
      startYear.getMonth(),
      startYear.getDate()
    );

    if (today < anniversary) {
      years -= 1;
    }

    return years;
  }, []);

  // Data counter
  const counter = useMemo(
    () => [
      {
        id: 1,
        title: experienceYears,
        suffix: "th",
        text: "Experiences",
      },
      {
        id: 2,
        title: _recap.members,
        suffix: "",
        text: "Members",
      },
      {
        id: 3,
        title: _recap.students,
        suffix: "",
        text: "Students",
      },
      {
        id: 4,
        title: 8,
        suffix: "",
        text: "Branch diseluruh Indonesia",
      },
    ],
    [experienceYears, _recap]
  );

  return (
    <section className="counter-section4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12 counter-inner">
            <div className="row">
              {counter.map((data) => (
                <div className="col-lg-3 col-md-6" key={data.id}>
                  <div className="counter-item mb-5 mb-lg-0">
                    <div className="count">
                      <span className="counter h2">
                        <CountUp end={data.title} enableScrollSpy redraw />
                        {data.suffix}
                      </span>
                    </div>
                    <p>{data.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;